import { StopAutoplayCommand } from "slotworks/commands/autoplay/stop-autoplay";
import { ButtonEvent } from "slotworks/graphics/elements/button-element";
import FlexiButton from "slotworks/graphics/elements/flexi-button";
import Layers from "slotworks/graphics/layers/layers";
import AutoplayModel from "slotworks/model/autoplay-model";
import AbstractButtonBehaviour from "slotworks/smart-button/behaviours/abstract-button-behaviour";
import StateMachine from "slotworks/state-machine/state-machine";
import settingsModel from "slotworks/model/settings/settings-model";

export default class CancelAutoButtonBehaviour extends AbstractButtonBehaviour {

    private skipButton: FlexiButton;
    private autoSkipButton: FlexiButton;

    public init() {

        Layers.SmartButton.setScene("auto").execute();
        this.button = Layers.SmartButton.getFlexiButton("stop");

        this.button.on(ButtonEvent.POINTER_DOWN, this.cancelAuto);

        const autoplaysText = Layers.SmartButton.getFlexiText("value");
        if (autoplaysText) {
            autoplaysText.setText(AutoplayModel.getAutoplays().toString());
        }

        // Skip button if present
        this.skipButton = Layers.SmartButton.getFlexiButton("skip");
        if (this.skipButton) {
            if(settingsModel.isSkipDisabled()) {
                this.skipButton.setEnabled(false);
            } else {
                this.skipButton.on(ButtonEvent.POINTER_DOWN, this.skip);
            }
        }

        this.autoSkipButton = Layers.SmartButton.getFlexiButton("autonext");
        if (this.autoSkipButton) {
            if(settingsModel.isSkipDisabled()) {
                this.autoSkipButton.setEnabled(false);
                this.autoSkipButton.setVisible(false);
            } else {
                this.autoSkipButton.on(ButtonEvent.POINTER_DOWN, this.skip);
            }
        }
    }

    public destroy() {
        this.button.off(ButtonEvent.POINTER_DOWN, this.cancelAuto);

        if (this.skipButton) {
            if(!settingsModel.isSkipDisabled()) {
                this.skipButton.off(ButtonEvent.POINTER_DOWN, this.skip);
            }
        }

        if (this.autoSkipButton) {
            if(!settingsModel.isSkipDisabled()) {
                this.autoSkipButton.off(ButtonEvent.POINTER_DOWN, this.skip);
            }
        }

        super.destroy();
    }

    private cancelAuto = () => {
        StopAutoplayCommand();
    }

    private skip = () => {
        StateMachine.skip();
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/smart-button/behaviours/cancel-auto-button-behaviour.ts